import React from 'react';
import { graphql, StaticQuery } from 'gatsby';
import styles from './style.module.css';

interface Props {
  data: any;
}

export const RenderSideBanner = ({ data }: Props) => {
  const getWhatsAppLink = () => {
    const wattsMessage = `Olá, vi um anúncio no site Autoscar.com.br e gostaria de mais informações sobre a vistoria cautelar! ${
      typeof window !== 'undefined' ? window.location.href : ''
    }`;
    const encodedMessage = encodeURIComponent(wattsMessage);
    return `https://wa.me/553498121600?text=${encodedMessage}`;
  };

  const banners = data?.filter(item => item.position === 'sideAdsBanner');

  return (
    <div className={styles.sideBannerContainer}>
      {banners?.map((banner, position) => (
        <a
          key={position}
          href={getWhatsAppLink()}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.bannerLink}
        >
          <img
            src={banner.large_image.data.full_url}
            alt={`banner ${position}`}
            className={styles.bannerImage}
          />
        </a>
      ))}
    </div>
  );
};

export const SideBanner = () => {
  const banners = graphql`
    query {
      allDirectusBanner {
        nodes {
          city {
            city_name
          }
          position
          link
          large_image {
            data {
              full_url
            }
          }
        }
      }
    }
  `;

  const renderSideBanner = (data: any) => {
    const {
      allDirectusBanner: { nodes },
    } = data;
    return <RenderSideBanner data={nodes} />;
  };

  return <StaticQuery query={banners} render={renderSideBanner} />;
};
